module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_arrow_left02-407421fa9089e79465591f1a0f76d601.svg";